import { redirect, RouterProvider } from '@tanstack/react-router';

import { queryClient } from '@/app/lib/tanstack-query';
import { router } from '@/app/lib/tanstack-router';
import { store } from '@/app/stores/redux-store';
import { getCurrentUserQueryOptions } from '@/shared/user/queries';

export function AppRouter() {
  return (
    <RouterProvider
      router={router}
      defaultPreload="intent"
      scrollRestoration={true}
      defaultStaleTime={1}
      context={{
        queryClient,
        store,
        ensureUser: async () => {
          const user = await queryClient.ensureQueryData({ ...getCurrentUserQueryOptions() });

          if (!user) {
            throw redirect({ to: '/login' }); // TODO get the current location and use it on login
          }

          return user;
        }
      }}
    />
  );
}
